import OrganizationPage from "@/app/organization/settings/organization/organization.page";
import TeamMemberDetail from "@/app/organization/settings/teammembers-detail/teammembers-detail.page";
import TeamMembersPage from "@/app/organization/settings/teammembers/teammembers.page";

export const organization_routes = [
  {
    path: "/settings/organization",
    element: <OrganizationPage />,
  },
  {
    path: "/settings/team-members",
    element: <TeamMembersPage />,
  },
  {
    path: "/settings/team-members/:memberId",
    element: <TeamMemberDetail />,
  },
];
